import { createFileRoute } from '@tanstack/react-router'
import { DocumentUploadPage } from 'pages/documentUpload/DocumentUploadPage'
import { z } from 'zod'

const documentUploadSearchSchema = z.object({
  document: z.string().optional(),
})

export const Route = createFileRoute('/document-upload/$assetId')({
  component: DocumentUploadPage,
  validateSearch: documentUploadSearchSchema,
  staticData: {
    title: 'Document Upload',
  },
})
